import { AuthEvent as e } from "./AuthEvent.mjs";
import { z as t } from "zod";
//#region src/verticals/auth/AuthEventPayloads.ts
var n = t.enum([
	"password",
	"google",
	"apple"
]), r = t.object({ method: n }), i = t.object({
	method: n,
	userId: t.string().uuid()
}), a = t.object({
	method: n,
	reason: t.string()
}), o = t.object({
	userId: t.string().uuid(),
	method: n
}), s = t.object({ reason: t.string().optional() }), c = {
	[e.LoginAttempted]: r,
	[e.LoginSucceeded]: i,
	[e.LoginFailed]: a,
	[e.SignupCompleted]: o,
	[e.LoggedOut]: s
};
//#endregion
export { c as AuthEventSchemas };
